var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({attrs:{"disabled":_vm.running},on:{"click":_vm.performAction}},'b-button',_vm.$attrs,false),[_c('div',{class:{flashing: _vm.running}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }